import { SimplePlaceholder } from "@components"
import { Square3Stack3DIcon } from "@heroicons/react/24/outline"
import { Button } from "@heroui/react"
import PropTypes from "prop-types"

const SessionErrorPlaceholder = ({ handleCancel, title, description }) => (
  <SimplePlaceholder 
    icon={Square3Stack3DIcon} 
    title={title}
  >
    <p className="mt-2 mb-4 text-sm text-gray-500">
      {description}
    </p>

    <Button className="font-semibold"color="secondary" fullWidth onPress={handleCancel}>Back to Sessions</Button>
  </SimplePlaceholder>
)

SessionErrorPlaceholder.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default SessionErrorPlaceholder